import React from 'react'

const ScreenLoader = () => {
    return (
        <div className='screen-loader'><span className="loader"></span></div>
    )
}

export default ScreenLoader